import { Component, OnInit, Input } from '@angular/core';
import { BaseComponent } from "../classes/BaseComponent";


@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent extends BaseComponent implements OnInit {
  @Input() faqCategory: string;

  faqs = [];

  toggleFAQ(faq: any): void {
    faq.expanded = !faq.expanded;
  }
  constructor() {
    super();
  }

  ngOnInit() {
    this.loadFaqs();
  }

  loadFaqs(): void {
    switch (this.faqCategory) {
      case 'itunes-movie-deals':
        this.faqs = [
          { question: this.getString('itunesMovieDealsFaqQ1'), answer: this.getString('itunesMovieDealsFaqA1'), expanded: false },
          { question: this.getString('itunesMovieDealsFaqQ2'), answer: this.getString('itunesMovieDealsFaqA2'), expanded: false },
          { question: this.getString('itunesMovieDealsFaqQ3'), answer: this.getString('itunesMovieDealsFaqA3'), expanded: false },
          { question: this.getString('itunesMovieDealsFaqQ4'), answer: this.getString('itunesMovieDealsFaqA4'), expanded: false },
          { question: this.getString('itunesMovieDealsFaqQ5'), answer: this.getString('itunesMovieDealsFaqA5'), expanded: false },
          { question: this.getString('itunesMovieDealsFaqQ6'), answer: this.getString('itunesMovieDealsFaqA6'), expanded: false },
          { question: this.getString('itunesMovieDealsFaqQ7'), answer: this.getString('itunesMovieDealsFaqA7'), expanded: false },
          { question: this.getString('itunesMovieDealsFaqQ8'), answer: this.getString('itunesMovieDealsFaqA8'), expanded: false }
        ];
        break;
      case 'prime-video-deals':
        this.faqs = [
          { question: this.getString('primeVideoDealsFaqQ1'), answer: this.getString('primeVideoDealsFaqA1'), expanded: false },
          { question: this.getString('primeVideoDealsFaqQ2'), answer: this.getString('primeVideoDealsFaqA2'), expanded: false },
          { question: this.getString('primeVideoDealsFaqQ3'), answer: this.getString('primeVideoDealsFaqA3'), expanded: false },
          { question: this.getString('primeVideoDealsFaqQ4'), answer: this.getString('primeVideoDealsFaqA4'), expanded: false },
          { question: this.getString('primeVideoDealsFaqQ5'), answer: this.getString('primeVideoDealsFaqA5'), expanded: false },
          { question: this.getString('primeVideoDealsFaqQ6'), answer: this.getString('primeVideoDealsFaqA6'), expanded: false },
          { question: this.getString('primeVideoDealsFaqQ7'), answer: this.getString('primeVideoDealsFaqA7'), expanded: false }
        ];
        break;
      case 'vudu-movie-deals':
        this.faqs = [
          { question: this.getString('vuduMovieDealsFaqQ1'), answer: this.getString('vuduMovieDealsFaqA1'), expanded: false },
          { question: this.getString('vuduMovieDealsFaqQ2'), answer: this.getString('vuduMovieDealsFaqA2'), expanded: false },
          { question: this.getString('vuduMovieDealsFaqQ3'), answer: this.getString('vuduMovieDealsFaqA3'), expanded: false },
          { question: this.getString('vuduMovieDealsFaqQ4'), answer: this.getString('vuduMovieDealsFaqA4'), expanded: false },
          { question: this.getString('vuduMovieDealsFaqQ5'), answer: this.getString('vuduMovieDealsFaqA5'), expanded: false },
          { question: this.getString('vuduMovieDealsFaqQ6'), answer: this.getString('vuduMovieDealsFaqA6'), expanded: false },
          { question: this.getString('vuduMovieDealsFaqQ7'), answer: this.getString('vuduMovieDealsFaqA7'), expanded: false },
          { question: this.getString('vuduMovieDealsFaqQ8'), answer: this.getString('vuduMovieDealsFaqA8'), expanded: false }
        ];
        break;
      case 'itunes-movies-in-4k':
        this.faqs = [
          { question: this.getString('itunesMovies4KFaqQ1'), answer: this.getString('itunesMovies4KFaqA1'), expanded: false },
          { question: this.getString('itunesMovies4KFaqQ2'), answer: this.getString('itunesMovies4KFaqA2'), expanded: false },
          { question: this.getString('itunesMovies4KFaqQ3'), answer: this.getString('itunesMovies4KFaqA3'), expanded: false },
          { question: this.getString('itunesMovies4KFaqQ4'), answer: this.getString('itunesMovies4KFaqA4'), expanded: false },
          { question: this.getString('itunesMovies4KFaqQ5'), answer: this.getString('itunesMovies4KFaqA5'), expanded: false },
          { question: this.getString('itunesMovies4KFaqQ6'), answer: this.getString('itunesMovies4KFaqA6'), expanded: false },
          { question: this.getString('itunesMovies4KFaqQ7'), answer: this.getString('itunesMovies4KFaqA7'), expanded: false },
          { question: this.getString('itunesMovies4KFaqQ8'), answer: this.getString('itunesMovies4KFaqA8'), expanded: false },
        ];
        break;

      default:
        break;
    }
  }

}
